module.exports = __webpack_public_path__ + "home-partner-image-full-stack.1zdBbx3U.svg";